import styles from "../assets/stylesheets/global/_no_purge_label.module.scss";

const {
  sliceLargeText,
  sliceDefaultText,
  sliceSmallText,
  sliceLargeHeading,
  sliceMediumHeading,
  sliceSmallHeading,
  leftAlign,
  leftAlignMediumText,
  leftAlignLargeText,
  centerAlign,
  centerAlignMediumText,
  rightAlign,
  rightAlignLargeText,
  buttonFilled,
  buttonBordered,
  buttonEmpty,
  buttonFilledBeige,
  buttonBorderedBeige,
} = styles;

export const labelClassesMapping = {
  "slice-large-text": sliceLargeText,
  "slice-default-text": sliceDefaultText,
  "slice-small-text": sliceSmallText,
  "slice-large-heading": sliceLargeHeading,
  "slice-medium-heading": sliceMediumHeading,
  "slice-small-heading": sliceSmallHeading,
  "left-align": leftAlign,
  "left-align-medium-text": leftAlignMediumText,
  "left-align-large-text": leftAlignLargeText,
  "center-align": centerAlign,
  "center-align-medium-text": centerAlignMediumText,
  "right-align": rightAlign,
  "right-align-large-text": rightAlignLargeText,
  "button-filled": buttonFilled,
  "button-bordered": buttonBordered,
  "button-empty": buttonEmpty,
  "button-filled-beige": buttonFilledBeige,
  "button-bordered-beige": buttonBorderedBeige,
};
